import { CustomValidatorArgs } from '../types/CSVTypes';

const loadValidator = ({ value }: CustomValidatorArgs) => {
  const load = Number(value);
  if (!!load && load < 0) {
    return 'isNegative';
  }

  return null;
};

export default loadValidator;
